import React from "react";

const Markup = ({ renderField, Button, name }) => {
    return (
        <div>
            {renderField(name)}
            {!!Button && <Button />}
        </div>
    );
};

export default Markup;
